import React, { useMemo } from 'react';
import { IoPersonOutline, IoCheckmarkCircleOutline, IoTimeOutline } from 'react-icons/io5';
import { MdOutlineGroup } from 'react-icons/md';
import { StatisticCard } from '@/components/statisticCard';
import { AccountStatusEnum, ACCOUNT_STATUS_LABELS, ACCOUNT_STATUS_HEX_COLORS } from '../constants';

interface StatusCount {
  statuscode: number;
  'statuscode@OData.Community.Display.V1.FormattedValue'?: string;
  count: number;
  'count@OData.Community.Display.V1.FormattedValue'?: string;
}

interface StatisticsCardsProps {
  loading?: boolean;
  statusCounts?: StatusCount[];
  totalCount?: number;
}

interface StatusConfig {
  statuscode: number;
  label: string;
  icon: React.ReactNode;
  color: string;
}

const ALL_STATUSES: StatusConfig[] = [
  {
    statuscode: AccountStatusEnum.ACCOUNT_CREATED,
    label: ACCOUNT_STATUS_LABELS[AccountStatusEnum.ACCOUNT_CREATED],
    icon: <IoPersonOutline size={14} />,
    color: ACCOUNT_STATUS_HEX_COLORS[AccountStatusEnum.ACCOUNT_CREATED],
  },
  {
    statuscode: AccountStatusEnum.SETUP_IN_PROGRESS,
    label: ACCOUNT_STATUS_LABELS[AccountStatusEnum.SETUP_IN_PROGRESS],
    icon: <IoTimeOutline size={14} />,
    color: ACCOUNT_STATUS_HEX_COLORS[AccountStatusEnum.SETUP_IN_PROGRESS],
  },
  {
    statuscode: AccountStatusEnum.SETUP_COMPLETE,
    label: ACCOUNT_STATUS_LABELS[AccountStatusEnum.SETUP_COMPLETE],
    icon: <IoCheckmarkCircleOutline size={14} />,
    color: ACCOUNT_STATUS_HEX_COLORS[AccountStatusEnum.SETUP_COMPLETE],
  },
];

export const StatisticsCards: React.FC<StatisticsCardsProps> = ({ statusCounts, totalCount, loading }) => {
  const statusCountsMap = useMemo(() => {
    const map: Record<number, number> = {};
    statusCounts?.forEach((item) => {
      map[item.statuscode] = item.count;
    });
    return map;
  }, [statusCounts]);

  return (
    <div className="flex gap-4 overflow-x-auto" style={{ marginBottom: 24 }}>
      <StatisticCard
        title="Total Customers"
        value={totalCount ?? 0}
        icon={<MdOutlineGroup size={14} />}
        iconBgColor="#DC3B41"
        className="min-w-[160px]"
        enableAnimation={!loading}
      />
      {ALL_STATUSES.map((status) => (
        <StatisticCard
          key={status.statuscode}
          title={status.label}
          value={statusCountsMap[status.statuscode] ?? 0}
          icon={status.icon}
          iconBgColor={status.color}
          className="min-w-[160px]"
          enableAnimation={!loading}
        />
      ))}
    </div>
  );
};
